import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { 
    TasksByPracticeAreaResponse, 
    PracticeAreaResponse, 
    PracticeArea,
    ChartData 
} from '../components/tasks-by-practice-area/tasks-by-practice-area.models';

@Injectable({
    providedIn: 'root'
})
export class TasksByPracticeAreaService {
    private baseUrl = environment.main_url;

    constructor(private http: HttpClient) { }

    getPracticeAreas(): Observable<PracticeArea[]> {
        return this.http.get<PracticeAreaResponse>(`${this.baseUrl}/agilelegal/practiceArea`)
            .pipe(
                map(response => response.data)
            );
    }

    getTasksByPracticeArea(practiceAreaNames?: string[]): Observable<ChartData[]> {
        // Create the base URL
        const url = `${this.baseUrl}/agilelegal/reports/tasks/by-practicearea`;
        let params = new HttpParams();
        
        // Add practice area parameter if areas are selected
        if (practiceAreaNames && practiceAreaNames.length > 0) {
            // Convert the array to a comma-separated string
            const practiceAreaParam = practiceAreaNames.join(',');
            // Add as a query parameter
            params = params.set('practiceArea', practiceAreaParam);
        }
        
        return this.http.get<TasksByPracticeAreaResponse>(url, { params })
            .pipe(
                map(response => response.data.map(item => ({
                    name: item.practiceArea,
                    value: item.taskCount
                })))
            );
    }
}
